module.exports = __webpack_public_path__ + "img/hôpital.b84a18af.png";